import { ThemeProvider } from "@mui/material";
import dayjs from "dayjs";
import theme from "./theme/primary";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import AuthenticatedLayout from "@components/layouts/AuthenticatedLayout";
import Configuration from "./pages/Configuration";
import UnauthenticatedLayout from "@components/layouts/UnauthenticatedLayout";
import Login from "./pages/Login";
import { Home } from "./includes";
import Status from "./pages/Status";
import Admin from "./pages/Admin";
import AdminCompany from "./pages/Admin/AdminCompany";

dayjs.locale("fr");

function App() {
  const router = createBrowserRouter([
    {
      path: "/login",
      element: <UnauthenticatedLayout />,
      children: [
        {
          path: "",
          element: <Login />,
        },
      ],
    },
    {
      path: "/",
      element: <AuthenticatedLayout />,
      children: [
        {
          path: "/configuration/*",
          element: <Configuration />,
        },
        {
          path: "/status",
          element: <Status />,
        },
        {
          path: "/admin",
          element: <Admin />,
        },
        {
          path: "/admin/company/:id",
          element: <AdminCompany />,
        },
        {
          path: "",
          element: <Home />,
        },
      ],
    },
  ]);

  return (
    <ThemeProvider theme={theme}>
      <RouterProvider router={router}></RouterProvider>
    </ThemeProvider>
  );
}

export default App;
